/* Mayekoo FAQ page — live search. Vanilla JS, dependency-free, theme-editor safe. */
(function () {
  'use strict';

  var GLOBAL_KEY = '__mayekooFaqV3Bound';
  if (window[GLOBAL_KEY]) return;
  window[GLOBAL_KEY] = true;

  function getCurrentNodes() {
    return {
      input: document.querySelector('[data-mk-faq-search]'),
      main: document.querySelector('[data-mk-faq-main]')
    };
  }

  function setExpanded(faq, expanded) {
    if (expanded) faq.setAttribute('open', '');
    else faq.removeAttribute('open');
  }

  function applyFilter(input) {
    var nodes = getCurrentNodes();
    var main = nodes.main;
    if (!input || !main) return;

    var query = input.value.trim().toLocaleLowerCase();
    var groups = main.querySelectorAll('[data-mk-group]');
    var chips = main.querySelector('[data-mk-chips]');
    var noResults = main.querySelector('[data-mk-noresults]');
    var liveStatus = main.querySelector('[data-mk-search-status]');
    var total = 0;

    groups.forEach(function (group) {
      var visible = 0;
      var faqs = group.querySelectorAll('[data-mk-faq]');

      faqs.forEach(function (faq) {
        var haystack = (faq.textContent || '').toLocaleLowerCase();
        var hit = !query || haystack.indexOf(query) !== -1;

        faq.setAttribute('data-mk-hit', hit ? '1' : '0');
        if (hit) visible += 1;

        if (query && hit) setExpanded(faq, true);
        else if (!query) setExpanded(faq, false);
      });

      group.setAttribute('data-mk-empty', visible ? '0' : '1');
      total += visible;
    });

    if (chips) chips.hidden = Boolean(query);
    if (noResults) noResults.hidden = !(query && total === 0);

    if (liveStatus) {
      if (!query) liveStatus.textContent = '';
      else if (total === 0) liveStatus.textContent = 'No matching frequently asked questions found.';
      else liveStatus.textContent = total + (total === 1 ? ' matching question found.' : ' matching questions found.');
    }
  }

  /* Event delegation means replaced Shopify sections never leave stale element references. */
  document.addEventListener('input', function (event) {
    var target = event.target;
    if (target && target.matches && target.matches('[data-mk-faq-search]')) {
      applyFilter(target);
    }
  });

  /* Re-apply the current query when either FAQ section is re-rendered in the theme editor. */
  document.addEventListener('shopify:section:load', function () {
    var nodes = getCurrentNodes();
    if (nodes.input && nodes.main) applyFilter(nodes.input);
  });
})();
